import { createRef, ChangeEvent, useEffect } from "react";

import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { ICreateOperadora } from "src/Contexts/comissoes/ComissoesTypes";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";

export const FormularioAdministradoras = () => {
  const { valuesInputsAdministradora, setValuesInputsAdministradora } =
    useContextComissoes();

  const refOrigem = createRef<HTMLInputElement>();
  const handleFocusedID = () => refOrigem.current?.focus();

  useEffect(() => {
    handleFocusedID();
  }, []);

  const handleChange =
    (prop: keyof ICreateOperadora) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      setValuesInputsAdministradora((eventPrev) => ({
        ...eventPrev,
        [prop]: event.target.value,
      }));
    };

  return (
    <AppTextField
      fullWidth
      inputRef={refOrigem}
      label="Administradora *"
      value={valuesInputsAdministradora?.name}
      onChange={handleChange("name")}
    />
  );
};
